export default __webpack_public_path__ + "static/media/QuATRo_Siegel_2023_Silber.24d2a8b4.svg";